(function (win) {
  function createCORSRequest(method, url, callback) {
    var xhr = new XMLHttpRequest();
    if ("withCredentials" in xhr) {
      // Check if the XMLHttpRequest object has a "withCredentials" property.
      // "withCredentials" only exists on XMLHTTPRequest2 objects.
      xhr.open(method, url, true);
    } else if (typeof window.XDomainRequest != "undefined") {
      // Otherwise, check if XDomainRequest.
      // XDomainRequest only exists in IE, and is IE's way of making CORS requests.
      xhr = new window.XDomainRequest();
      xhr.open(method, url);
    } else {
      // Otherwise, CORS is not supported by the browser.
      throw new Error("CORS not supported");
    }

    xhr.onload = function () {
      callback(null, xhr);
    };
    xhr.onerror = function (err) {
      callback(err, null);
    };
    return xhr;
  }

  win.CORS = createCORSRequest;
  win.CORS.get = function (url, callback) {
    return createCORSRequest("GET", url, callback);
  };
})(window);
